import axiosInstance from "../Axios";
const getApplyResignationData = async () => {
  try {
    return axiosInstance.get("/exit-management/apply-resignation");
  } catch (error) {
    console.error("Error fetching resignation data:", error);
    throw error; // Re-throwing allows calling code to handle the error too
  }
};

const submitResignationData = async (data) => {
  try {
    return axiosInstance.post("/exit-management/apply-resignation", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  } catch (error) {
    console.error("Error submitting resignation data:", error);
    throw error;
  }
};

const getSubmittedResignationData = async (pageNo, params) => {
  try {
    return axiosInstance.get(
      "/exit-management/submitted-resignation?pageNo=" + pageNo,
      { params: params }
    );
  } catch (error) {
    console.error("Error fetching submitted resignation data:", error);
    throw error;
  }
};
const withdrawResignation = async (id, remarks, action) => {
  try {
    return axiosInstance.patch(
      "/exit-management/withdraw-resignation?resignationId=" +
        id +
        "&action=" +
        action +
        "&remarks=" +
        remarks
    );
  } catch (error) {
    console.error("Error withdrawing resignation:", error);
    throw error;
  }
};

const getResignationDetails = async (resignationId) => {
  try {
    return axiosInstance.get(`/exit-management/${resignationId}`);
  } catch (error) {
    console.error("Error fetching resignation details:", error);
    throw error;
  }
};

const acceptRejectResignation = async (
  resignationId,
  action,
  remarks,
  acceptData = {}
) => {
  try {
    const requestBody = { action, remarks, ...acceptData };
    return axiosInstance.patch(
      `/exit-management/${resignationId}/accept-reject-resignation`,
      requestBody
    );
  } catch (error) {
    console.error("Error accepting/rejecting resignation:", error);
    throw error;
  }
};

const downloadResignationDocument = async (fileName) => {
  try {
    return await axiosInstance.get("/exit-management/download", {
      params: { fileName: fileName },
      responseType: "blob",
    });
  } catch (error) {
    console.error("Error downloading resignation document:", error);
    throw error;
  }
};

const scheduleRoundTable = async (resignationId, data) => {
  try {
    return axiosInstance.patch(
      `/exit-management/${resignationId}/schedule-round-table`,
      data
    );
  } catch (error) {
    console.error("Error scheduling round table:", error);
    throw error;
  }
};
const fetchDepartments = async (params = { _DeptStatus: 1 }) => {
  try {
    return axiosInstance.get("/departments", { params: params });
  } catch (err) {
    console.error(err);
  }
};

const fetchReportingManagers = async () => {
  try {
    return axiosInstance.get("/users/get-reporting-managers");
  } catch (err) {
    console.error(err);
  }
};

const updateActualLastWorkingDay = async (resignationId, data) => {
  try {
    return axiosInstance.patch(
      `/exit-management/${resignationId}/update-last-working-day`,
      data
    );
  } catch (error) {
    console.error("Error scheduling round table:", error);
    throw error;
  }
};

const uploadDocument = async (resignationId, data) => {
  try {
    return axiosInstance.patch(
      `/exit-management/${resignationId}/upload-document`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  } catch (error) {
    console.error("Error uploading document:", error);
    throw error;
  }
};

const exportResignationData = async (params) => {
  try {
    return axiosInstance.get("/exit-management/export", {
      params: params,
      responseType: "blob",
    });
  } catch (error) {
    console.error("Error exporting resignation data:", error);
    throw error;
  }
};

const deleteDocument = async (resignationId, filePath, docs) => {
  try {
    return axiosInstance.delete(
      `/exit-management/delete-document?filePath=${filePath}&resignationId=${resignationId}&docs=${docs}`
    );
  } catch (error) {
    console.error("Error deleting document:", error);
    throw error;
  }
};

// NOC setting: clearance departments
const getNocClearanceDepartments = async () => {
  try {
    return axiosInstance.get("/exit-management/noc/settings/departments");
  } catch (error) {
    console.error("Error fetching NOC clearance departments:", error);
    throw error;
  }
};

const getNocClearanceDepartmentDetails = async (id) => {
  try {
    return axiosInstance.get(`/exit-management/noc/settings/departments/${id}`);
  } catch (error) {
    console.error("Error fetching NOC clearance department:", error);
    throw error;
  }
};

const createNocClearanceDepartment = async (data) => {
  try {
    return axiosInstance.post("/exit-management/noc/settings/departments", data);
  } catch (error) {
    console.error("Error creating NOC clearance department:", error);
    throw error;
  }
};

const updateNocClearanceDepartment = async (id, data) => {
  try {
    return axiosInstance.patch(
      `/exit-management/noc/settings/departments/${id}`,
      data
    );
  } catch (error) {
    console.error("Error updating NOC clearance department:", error);
    throw error;
  }
};

const deleteNocClearanceDepartment = async (id) => {
  try {
    return axiosInstance.delete(
      `/exit-management/noc/settings/departments/${id}`
    );
  } catch (error) {
    console.error("Error deleting NOC clearance department:", error);
    throw error;
  }
};

// NOC approvals (assigned approver)
const getMyNocApprovals = async (pageNo = 1, params) => {
  try {
    return axiosInstance.get("/exit-management/noc/approvals", {
      params: { pageNo, ...params },
    });
  } catch (error) {
    console.error("Error fetching NOC approvals:", error);
    throw error;
  }
};

const getMyNocApprovalDetails = async (nocRequestId, departmentId) => {
  try {
    return axiosInstance.get(
      `/exit-management/noc/approvals/${nocRequestId}/departments/${departmentId}`
    );
  } catch (error) {
    console.error("Error fetching NOC approval details:", error);
    throw error;
  }
};

const actOnNocApproval = async (nocRequestId, departmentId, data) => {
  try {
    return axiosInstance.patch(
      `/exit-management/noc/approvals/${nocRequestId}/departments/${departmentId}/action`,
      data
    );
  } catch (error) {
    console.error("Error submitting NOC approval action:", error);
    throw error;
  }
};

const reassignNocDepartment = async (resignationId, departmentId, remarks) => {
  try {
    return axiosInstance.post(
      `/exit-management/noc/requests/${resignationId}/departments/${departmentId}/reassign`,
      { remarks }
    );
  } catch (error) {
    console.error("Error re-assigning NOC department:", error);
    throw error;
  }
};

const getNocHistory = async (resignationId) => {
  try {
    return axiosInstance.get(`/exit-management/noc/history/${resignationId}`);
  } catch (error) {
    console.error("Error fetching NOC history:", error);
    throw error;
  }
};

// Active, non-Employee-role users of a department - the only people who may
// be picked as the NOC approver for that department
const getNocDepartmentApprovers = async (departmentId, excludeUserId) => {
  try {
    return axiosInstance.get(
      `/exit-management/noc/departments/${departmentId}/approvers`,
      { params: excludeUserId ? { excludeUserId } : {} }
    );
  } catch (error) {
    console.error("Error fetching NOC department approvers:", error);
    throw error;
  }
};

// NOC requests
const getNocRequests = async (pageNo = 1, params) => {
  try {
    return axiosInstance.get("/exit-management/noc/requests", {
      params: { pageNo, ...params },
    });
  } catch (error) {
    console.error("Error fetching NOC requests:", error);
    throw error;
  }
};

const getNocRequestDetails = async (resignationId) => {
  try {
    return axiosInstance.get(`/exit-management/noc/requests/${resignationId}`);
  } catch (error) {
    console.error("Error fetching NOC request details:", error);
    throw error;
  }
};

const initiateNoc = async (resignationId, departments) => {
  try {
    return axiosInstance.post(
      `/exit-management/noc/requests/${resignationId}/initiate`,
      { departments }
    );
  } catch (error) {
    console.error("Error initiating NOC:", error);
    throw error;
  }
};

export {
  getApplyResignationData,
  submitResignationData,
  getSubmittedResignationData,
  withdrawResignation,
  getResignationDetails,
  acceptRejectResignation,
  downloadResignationDocument,
  scheduleRoundTable,
  fetchDepartments,
  fetchReportingManagers,
  updateActualLastWorkingDay,
  uploadDocument,
  exportResignationData,
  deleteDocument,
  getNocClearanceDepartments,
  getNocClearanceDepartmentDetails,
  createNocClearanceDepartment,
  updateNocClearanceDepartment,
  deleteNocClearanceDepartment,
  getNocRequests,
  initiateNoc,
  getNocRequestDetails,
  getNocDepartmentApprovers,
  getMyNocApprovals,
  getMyNocApprovalDetails,
  actOnNocApproval,
  getNocHistory,
  reassignNocDepartment,
};
